// extracted by mini-css-extract-plugin
export var additionalHighlightRow = "Results-module--additionalHighlightRow--b3ccb";
export var blue = "#0eb3f2";
export var cluster = "Results-module--cluster--bdbdc";
export var content = "Results-module--content--767df";
export var countdown = "Results-module--countdown--1f22a";
export var displayInlineBlock = "Results-module--displayInlineBlock--218ed";
export var emphasis = "Results-module--emphasis--c0a8c";
export var green = "#57d33b";
export var greenLink = "Results-module--green-link--e2b10";
export var grey = "var(--tone-mid)";
export var highlightRow = "Results-module--highlightRow--9c9b5";
export var icon = "Results-module--icon--4d29b";
export var iconWrapper = "Results-module--iconWrapper--2f166";
export var index = "Results-module--index--2724b";
export var indexHeader = "Results-module--indexHeader--3eb0c";
export var indexHeaderSticky = "Results-module--indexHeaderSticky--6faf0";
export var indexName = "Results-module--indexName--273a2";
export var link = "Results-module--link--e9ea2";
export var message = "Results-module--message--e1ac5";
export var moreResults = "Results-module--moreResults--90c4c";
export var moreResultsInner = "Results-module--moreResultsInner--b7d0d";
export var noResultsContainer = "Results-module--noResultsContainer--be238";
export var noResultsSubtitle = "Results-module--noResultsSubtitle--13b63";
export var notchGap = "32px";
export var orange = "#f8662b";
export var promoIcon = "Results-module--promoIcon--3c1b6";
export var raceNumber = "Results-module--raceNumber--30856";
export var red = "#ff2741";
export var resultsContainer = "Results-module--resultsContainer--61924";
export var row = "Results-module--row--4e7d6";
export var rows = "Results-module--rows--dc53c";
export var subTitle = "Results-module--subTitle--e726b";
export var title = "Results-module--title--1a15b";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";